import React from 'react';
import { TOOLTIP_POSITION } from 'react-covideo-common/dist/components/Tooltip/types';
import styled, { useTheme } from 'styled-components/macro';
import { Tooltip } from 'react-covideo-common';
import { MdInfo } from 'react-icons/md';

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

export const FormikLabelInfo = ({
  info,
  tooltipPosition,
}: {
  info: string | React.ReactNode;
  tooltipPosition?: TOOLTIP_POSITION | undefined;
}) => {
  const { colors } = useTheme();

  return (
    <TooltipContainer>
      <Tooltip
        popup={info}
        position={tooltipPosition || 'bottom'}
        extendStyles={{
          popup: {
            width: '310px',
            fontSize: '14px',
            lineHeight: '24px',
            color: colors.neutral[80],
            padding: '8px 12px',
            zIndex: 9999,
          },
          element: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          },
        }}
      >
        <MdInfo size={18} style={{ display: 'inline' }} />
      </Tooltip>
    </TooltipContainer>
  );
};
